/** @jsx jsx */
import { jsx } from 'theme-ui';
import { ErrorProvider } from '../context/ErrorContext';
import { ControlLabel } from './ControlLabel';
export var FormGroup = function (_a) {
    var controlId = _a.controlId, label = _a.label, help = _a.help, error = _a.error, children = _a.children, className = _a.className, optional = _a.optional;
    return (jsx("div", { className: className, id: controlId && "".concat(controlId, "_group"), sx: { mb: 3, '&>&': { mb: 2 } } },
        label && (jsx(ControlLabel, { id: "".concat(controlId, "_label"), htmlFor: controlId, variant: error ? 'error' : 'default', optional: optional }, label)),
        jsx(ErrorProvider, { value: error }, children),
        typeof error === 'string' && (jsx("div", { sx: { color: 'danger', my: 1 }, id: controlId && "".concat(controlId, "_error") }, error)),
        help && (jsx("div", { id: controlId && "".concat(controlId, "_help"), sx: { color: 'muted', fontSize: 1, mt: 1 } }, help))));
};
//# sourceMappingURL=FormGroup.js.map